module.exports = __webpack_public_path__ + "static/media/content-1.3f86050e.png";